export enum LoginButtonType {
    BankId = "bank-id",
    LocalLogin = "local-login",
    LocalRegistration = "local-registration",
}
